import Vue from 'vue'

class BaseApi {
  constructor(endpoint, version = 'v2') {
    this.baseURL = '/api';
    this.version = version;
    this.url = `${this.baseURL}/${this.version}/${endpoint}`;
  }

  async request(response) {
    if(response.status == 200 || response.status == 304) {
      return response;
    } else {
      return null;
    }
  }

  async get(params = {}) {
    try {
      const response = await Vue.axios.get(this.url, params);
      return this.request(response);
    } catch (e) {
      console.log(e)
      return null;
    }
  }

  async put(recordId, params = {}) {
    try {
      const response = await Vue.axios.put(`${this.url}/${recordId}`, params);
      return this.request(response);
    } catch (e) {
      console.log(e)
      return null;
    }
  }
}

export default BaseApi;